import styled from "@emotion/styled";
import { Alert } from "@mui/material";
import type { ComponentProps } from "react";

import { SkiliticsIcon } from "../icons";
import { transientOptions } from "../utilities";

type Props = ComponentProps<typeof Alert> & {
  size?: "small" | "medium";
};

export const InfoBanner = ({ size, ...props }: Props) => {
  return (
    <StyledAlert
      severity="info"
      $size={size}
      icon={
        <IconWrapper>
          <SkiliticsIcon icon="info" />
        </IconWrapper>
      }
      {...props}
    />
  );
};

const IconWrapper = styled.div`
  color: ${({ theme }) => theme.onPrimaryContainer};
  font-size: 18px;
`;

const StyledAlert = styled(Alert, transientOptions)<{ $size?: "small" | "medium" }>`
  background: ${({ theme }) => theme.primaryContainer};
  color: ${({ theme }) => theme.onPrimaryContainer};
  font-size: ${({ theme }) => theme.fontSize};
  align-items: center;
  padding: 0 12px;

  ${({ $size, theme }) =>
    $size === "small" &&
    `
      padding: 0 8px;
      font-size: ${theme.fontSizeSmall};
      ${IconWrapper} {
        font-size: 14px;
        margin-right: -5px;
      }
  `}
`;
